/* eslint-disable @typescript-eslint/no-explicit-any */
export class FailureResponse<T = any> implements ApplicationContract<T> {
  body?: T;
  statusCode?: number;

  constructor(statusMessage: T, statusCode: number) {
    this.body = statusMessage ? statusMessage : ('Something went wrong. Please try again.' as any);
    this.statusCode = statusCode;
  }
}

export class FailureContract<T = any> implements ApiContract<T> {
  payload: T;
  statusMessage: string;
  isSuccessful: boolean;

  constructor(statusMessage: T, statusCode: number) {
    this.isSuccessful = false;
    this.payload = statusMessage ? statusMessage : ('Something went wrong. Please try again.' as any);
    this.statusMessage = statusCode + '';
  }
}

export interface ApplicationContract<T> {
  statusCode?: number;
  body?: T;
}

export interface ApiContract<T> {
  isSuccessful: boolean;
  payload: T;
  statusMessage: string;
}

export enum AccessRoleEnum {
  Home = 'home',
  Preverification = 'preverification',
  Dreams = 'dreams',
  Rehash = 'rehash',
  /** SFS Rehash Tool — visible for dealers with risk_dealer_pricing_group = SFS (AOS-5218) */
  RehashSfs = 'rehash-sfs'
}

export interface AcadvModule {
  title: string;
  url: string;
  role: AccessRoleEnum;
}

export const AcadvModuleMap: { [key: string]: AcadvModule } = {
  [AccessRoleEnum.Home]: {
    title: 'Home',
    url: '/dashboard',
    role: AccessRoleEnum.Home
  },
  [AccessRoleEnum.Rehash]: {
    title: 'Deal Rehash',
    url: '/rehash',
    role: AccessRoleEnum.Rehash
  },
  [AccessRoleEnum.Preverification]: {
    title: 'Pre-Verification',
    url: '/preverification',
    role: AccessRoleEnum.Preverification
  },  
  [AccessRoleEnum.Dreams]: {
    title: 'DREAMS',
    url: '/dreams',
    role: AccessRoleEnum.Dreams
  },
  /** Key must be camelCase to match the User class property 'rehashSfs' */
  rehashSfs: {
    title: 'SFS Rehash',
    url: '/rehash-sfs',
    role: AccessRoleEnum.RehashSfs
  }
};

export enum AcadvAppEvents {
  FilesDropped = 'FilesDropped',
  NotificationCountUpdate = 'NotificationCountUpdate',
}

export interface DealerChangeModel {
  dealerNumber: number;
  subsequentRouteChange: boolean;
}
